import React, { useState, useEffect } from "react";
import { FormControl, Select, MenuItem } from "@mui/material";

export const MuiComboBox = (props) => {
  const { name, id, list, onChange } = props;
  const [selectedOption, setSelectedOption] = useState({});

  useEffect(() => {
    setSelectedOption({});
  }, [list]);

  const handleMenuItemClick = (option) => {
    setSelectedOption(option);
    onChange(name, id, option?.id);
  };

  return (
    <FormControl
      id={"formComboBox_" + id}
      name={"formComboBox_" + id}
      fullWidth
    >
      <Select
        MenuProps={{
          autoFocus: false,
          MenuListProps: {
            autoFocusItem: false,
          },
        }}
        id={id?.toString()}
        value={selectedOption?.label || ""}
        size="small"
        label=""
      >
        {list.map((option) => (
          <MenuItem
            key={option.id}
            value={option.label}
            onClick={() => handleMenuItemClick(option)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
